import { Input } from '@components/styled/Input.styled';
import { Option } from '@components/styled/Option.styled';
import { Select } from '@components/styled/Select.styled';
import styled from 'styled-components';
import { InputRow } from './InputRow.styled';

export const HomeTypeGroup = styled(InputRow)`
    ${Select} {
        z-index: 999;
    }

    ${Input},
    ${Option} {
        text-transform: capitalize;
    }

    ${Option} {
        cursor: pointer;
    }
`;
